interface FooterProps {
  siteName: string;
}

export function Footer({ siteName }: FooterProps) {
  return (
    <footer className="border-t border-light-border py-12 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div>
            <h3 className="text-lg font-semibold text-light-text mb-4">关于{siteName}</h3>
            <p className="text-sm text-light-muted leading-relaxed">
              {siteName}是一个 AI 图片生成平台，基于 GPT Image 2 和 Gemini 等先进模型，
              提供高质量的 AI 绘画服务。支持文生图、参考图生图、局部重绘三种模式。
              注册即送 2 积分，支持中文提示词，无需下载安装任何软件。
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-light-text mb-4">About {siteName}</h3>
            <p className="text-sm text-light-muted leading-relaxed">
              {siteName} is an AI image generation platform powered by GPT Image 2 and Gemini models.
              Supports text-to-image, image-to-image, and inpainting modes.
              Use it free online — no download, no subscription needed.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-light-text mb-4">功能特性 Features</h3>
            <ul className="space-y-2 text-sm text-light-muted">
              <li className="flex items-start gap-2">
                <span className="text-accent-blue mt-1">▸</span>
                <span>文生图 — 用文字描述生成高质量图片</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent-blue mt-1">▸</span>
                <span>参考图生图 — 基于参考图生成新图片（支持1-16张）</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent-blue mt-1">▸</span>
                <span>局部重绘 — 涂抹区域进行智能重绘</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent-blue mt-1">▸</span>
                <span>中文支持 — 完美理解中文提示词</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-accent-blue mt-1">▸</span>
                <span>免费体验 — 注册即送积分，无需付费</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center text-sm text-light-muted">
          <p>© 2025 {siteName} - AI图片生成平台</p>
          <p className="mt-2">
            {siteName} | AI Image Generation | 免费AI绘画 | 文字生图 | AI图片编辑 | AI Art Generator
          </p>
        </div>
      </div>
    </footer>
  );
}
